import { useCallback } from 'react';
import { hasInternetAsync } from '@/screens/HomeTherapist/helpers';
import { useDialog } from './useDialog';
import { PREPARED_DIALOGS } from '@/components/ui/shared/Dialog/constants';

export function useNoInternetDialog() {
  const { showDialog } = useDialog();

  const checkInternet = useCallback(async () => {
    const internet = await hasInternetAsync();

    if (!internet) {
      showDialog(PREPARED_DIALOGS.noInternetDialog());
    }

    return internet;
  }, [showDialog]);

  return { checkInternet };
}
